import { useState, useCallback } from 'react'

export const useToggle = (value = false) => {
  const [state, setState] = useState(value)

  const toggle = useCallback(() => setState(v => !v), [])

  return [state, toggle]
}
